export default {
    get: function (url) {
        return new Promise(function (resolve, reject) {
            resolve({
                body: true
            });
        });
    }
}



// WEBPACK FOOTER //
// ./test/data/account/checkEmail.js